
import * as api from "../constant/NewAPI";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import Select from "react-select";
import * as XLSX1 from "xlsx";
import * as XLSX from "xlsx-js-style";
import { all_routes } from "../router/all_routes";
import Utils from "../constant/Utils";



const attendanceReport = () => {

    const routes = all_routes;

    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState('');
    const [instituteList, setInstituteList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [attendanceList, setAttendanceList] = useState([]);
    const [studList, setStudList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [detailsList, setDetailsList] = useState([]);
    const [groupId, setGroupId] = useState('');
    const [institutionId, setInstitutionId] = useState('');
    const [studId, setStudId] = useState('');
    const [batchId, setBatchId] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [attendnceType, setAttendnceType] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [toDate, setToDate] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [linkClicked, setLinkClicked] = useState(false);

    const reportType = [
        { label: "Institute", value: "1" },
        { label: "By Batch", value: "2" },
        { label: "By Student", value: "3" }
    ];
    useEffect(() => {
        instList()
    }, [])

    function instList() {
        const institute = api.InstitutionList;
        fetch(institute, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instReponse) => instReponse.json())
            .then((instResult) => {
                if (instResult.error == true) {
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (instResult.data != null) {
                        setInstituteList(instResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error)
            })
    }

    function getStudList() {
        const studlst = api.StudentsByBatch + '/' + institutionId;
        fetch(studlst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((studResponse) => studResponse.json())
            .then((studResult) => {
                if (studResult.error == true) {
                    if (studResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (studResult.data != null) {
                        setStudList(studResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch student list", error)
            })
    }

    function getBatchList() {
        const getbtchlst = api.BatchesByInst + '/' + roleId + '/' + institutionId;
        fetch(getbtchlst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((btchResponse) => btchResponse.json())
            .then((btchResult) => {
                if (btchResult.error == true) {
                    if (btchResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (btchResult.data != null) {
                        setBatchList(btchResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch batch list.", error)
            })
    }

    function atndcReport() {
        let atendncReport = api.YfhAttendanceReport + '/' + institutionId + '/' + fromDate + '/' + toDate + '/' + attendnceType;
        if (batchId) {
            atendncReport += '/' + batchId;
        } else if (studId) {
            atendncReport += '/' + studId;
        }
        fetch(atendncReport, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((statResponse) => statResponse.json())
            .then((statResult) => {
                if (statResult.error == true) {
                    if (statResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (statResult.data != null) {
                        setAttendanceList(statResult.data.attendance);
                    }
                    setShowTable(true)
                    setLinkClicked(true)
                }
            })
            .catch((error) => {
                console.log('Failed to fetch status report.', error)
            })
    }

    function showDetails(itm) {
        const scdlId = itm.attendanceScheduleId;
        const rprtAtndc = api.GetReportAttendanceDetails + '/' + scdlId + '/' + institutionId //"?ScheduleId=" + scdlId + "&Institute=" + institutionId;
        fetch(rprtAtndc, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((rprtResponse) => rprtResponse.json())
            .then((rprtResult) => {
                if (rprtResult.error == true) {
                    if (rprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (rprtResult.data != null) {
                        setDetailsList(rprtResult.data);
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch details list", error)
            })
    }

    function exportnow() {
        let exprt = api.YfhAttendanceReportExport + '/' + institutionId + '/' + fromDate + '/' + toDate + '/' + attendnceType;
        if (batchId) {
            exprt += '/' + batchId;
        } else if (studId) {
            exprt += '/' + studId;
        }
        fetch(exprt, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((exprtResponse) => exprtResponse.json())
            .then((exprtResult) => {
                if (exprtResult.error == true) {
                    if (exprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    // if (attendnceType === '1') {
                    exportToExcel(exprtResult.data)
                    // } else {
                    //     const blob = new Blob([exprtResult.data], { type: "application/vnd.ms-excel" });
                    //     const url = URL.createObjectURL(blob);
                    //     const a = document.createElement("a");
                    //     a.href = url;
                    //     a.download = "Attendance Report.xls"; // Save file as .xls
                    //     document.body.appendChild(a);
                    //     a.click();
                    //     document.body.removeChild(a);
                    //     URL.revokeObjectURL(url);
                    // }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch attendance report", error);
            })
    }

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const filteredData = attendanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const filteredAttendance = detailsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchQuery.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchRender = (rowData, column) => {
        return <span>{rowData.batchName}</span>
    };

    const dateRender = (rowData, column) => {
        return <span>{formatDate(rowData.scheduleDate)}</span>;
    };

    const skillRender = (rowData, column) => {
        return <span>{rowData.skillName}</span>
    };

    const studRender = (rowData, column) => {
        return <span>{rowData.studentName}</span>;
    };

    const attendanceRender = (rowData, column) => {
        return <span>{rowData.attendanceTypeName}</span>;
    };

    const commentRender = (rowData, column) => {
        return <span>{rowData.attendanceComments}</span>;
    };

    const detailsRender = (rowData) => {
        return (
            <Link to="#" data-bs-toggle="modal" data-bs-target="#attendance-list" onClick={() => { showDetails(rowData); }}>
                <i className="feather feather-eye"></i>View
            </Link>
        );
    };

    function exportToExcel(apiData) {
        const wb = XLSX.utils.book_new();
        const parser = new DOMParser();

        const dataObj =
            typeof apiData === "string"
                ? { Sheet1: apiData }
                : apiData;


        Object.keys(dataObj).forEach((teamKey) => {
            const htmlString = dataObj[teamKey];
            const doc = parser.parseFromString(htmlString, "text/html");

            const sheetData: any[] = [];
            let colCount = 0;

            // Main Title (h2)
            // const mainTitle = doc.querySelector("h2")?.textContent?.trim();
            // if (mainTitle) {
            //     sheetData.push([mainTitle]);
            //     sheetData.push([]);
            // }
            const h2Tags = doc.querySelectorAll("h2");

            h2Tags.forEach((h2) => {
                const text = h2.textContent?.trim();
                if (text) {
                    sheetData.push([text]);
                    sheetData.push([]); // spacing
                }
            });

            // All months + tables
            const headings = doc.querySelectorAll("h3");
            const tables = doc.querySelectorAll("table");

            tables.forEach((table, index) => {
                const heading = headings[index]?.textContent?.trim();

                // Month Title
                if (heading) {
                    sheetData.push([heading]);
                }

                const rows = table.querySelectorAll("tr");

                rows.forEach((row, rowIndex) => {
                    const cols = row.querySelectorAll("th, td");

                    if (rowIndex === 0) {
                        // colCount = cols.length;
                        colCount = Math.max(colCount, cols.length);
                    }

                    const rowData = Array.from(cols).map((col) =>
                        col.textContent?.trim() || ""
                    );

                    sheetData.push(rowData);
                });

                // Gap between months
                sheetData.push([]);
                sheetData.push([]);
            });

            // Create worksheet
            const ws = XLSX.utils.aoa_to_sheet(sheetData);

            // Basic Styling
            const borderStyle = {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" }
            };

            Object.keys(ws).forEach((cellRef) => {
                if (cellRef[0] === "!") return;

                const cell = ws[cellRef];
                const address = XLSX.utils.decode_cell(cellRef);

                const row = sheetData[address.r];

                if (!row) return;

                const isHeader = row.includes("Sl. No.");
                const isTableRow = row.length > 3; // table rows have multiple columns
                const isTitle = row.length === 1;

                // Always keep text + alignment
                if (cell.v !== undefined && cell.v !== null && cell.v !== "") {
                    cell.t = "s";
                    cell.s = {
                        alignment: {
                            horizontal: address.c === 1 ? "left" : "center",
                            vertical: "center",
                            wrapText: true
                        }
                    };

                    // Apply border ONLY to table rows
                    if (isTableRow) {
                        cell.s.border = borderStyle;
                    }

                    // Header styling
                    if (isHeader) {
                        cell.s.fill = { fgColor: { rgb: "D3D3D3" } };
                        cell.s.font = { bold: true };
                    }

                    // Title styling
                    if (isTitle) {
                        cell.s.font = { bold: true, sz: 14 };
                    }

                    // Red A
                    if (cell.v === "A") {
                        cell.s.font = { color: { rgb: "FF0000" }, bold: true };
                    }
                }
            });

            // Merge title rows
            if (!ws["!merges"]) ws["!merges"] = [];

            sheetData.forEach((row, i) => {
                if (row.length === 1 && colCount > 1) {
                    ws["!merges"].push({
                        s: { r: i, c: 0 },
                        e: { r: i, c: colCount - 1 }
                    });
                }
            });

            // Column width
            // ws["!cols"] = Array(colCount).fill({ wch: 18 });
            const colWidths = [];

            // for (let c = 0; c < colCount; c++) {
            //     let maxLength = 10;

            //     sheetData.forEach((row) => {
            //         if (row.length === 1) return;
            //         const cell = row[c];
            //         if (cell) {
            //             maxLength = Math.max(maxLength, cell.toString().length);
            //         }
            //     });

            //     colWidths.push({ wch: maxLength + 2 });
            // }

            for (let c = 0; c < colCount; c++) {
                if (c === 1) {
                    colWidths.push({ wch: 20 }); // Student Name
                // } else if (c === 2 || c === 3) {
                //     colWidths.push({ wch: 7 }); // Class & Gender
                } else {
                    colWidths.push({ wch: 9.5 }); // rest of the columns
                }
            }

            ws["!cols"] = colWidths;

            // Clean sheet name
            const sheetName = teamKey
                .replace(/[\\?*:[\]/]/g, "")
                .substring(0, 30);

            XLSX.utils.book_append_sheet(wb, ws, sheetName);
        });

        // Export
        XLSX.writeFile(wb, "Attendance Report.xlsx");

    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Attendance Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-primary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">

                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                                                        <Select value={instituteList.find(inst => inst.institutionId === institutionId) ? {
                                                                            value: institutionId,
                                                                            label: instituteList.find(inst => inst.institutionId === institutionId).institutionName
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setInstitutionId(e.value);
                                                                                setBatchId('');
                                                                                setStudId('');
                                                                            }}
                                                                            options={instituteList.map(inst => ({
                                                                                value: inst.institutionId,
                                                                                label: inst.institutionName
                                                                            }))}
                                                                            placeholder={"Select Institute"}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>Report Type</h6></label>
                                                                        <Select value={reportType.find(atnd => atnd.value === attendnceType) ? {
                                                                            value: attendnceType,
                                                                            label: reportType.find(atnd => atnd.value === attendnceType).label
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setAttendnceType(e.value)
                                                                                { e.value === '2' ? getBatchList() : e.value === '3' ? getStudList() : (setBatchList([]), setStudList([])) }
                                                                            }}
                                                                            options={reportType.map(atnd => ({
                                                                                value: atnd.value,
                                                                                label: atnd.label
                                                                            }))}
                                                                            placeholder={"Select Report Type"}
                                                                        />
                                                                    </div>
                                                                    {attendnceType === '2' && (
                                                                        <div className="col-lg-3 mb-10">
                                                                            <label className="sortbytitle"><h6>Batch</h6></label>
                                                                            <Select value={batchList.find(btch => btch.batchId === batchId) ? {
                                                                                value: batchId,
                                                                                label: batchList.find(btch => btch.batchId === batchId).batchName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setBatchId(e.value)
                                                                                    // setInstitutionId('');
                                                                                    setStudId('');
                                                                                }}
                                                                                options={batchList.map(btch => ({
                                                                                    value: btch.batchId,
                                                                                    label: btch.batchName
                                                                                }))}
                                                                                placeholder={"Select Batch"}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    {attendnceType === '3' && (
                                                                        <div className="col-lg-3 mb-10">
                                                                            <label className="sortbytitle"><h6>Student</h6></label>
                                                                            <Select value={studList.find(stud => stud.coreUserId === studId) ? {
                                                                                value: studId,
                                                                                label: studList.find(stud => stud.coreUserId === studId).coreUserName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setStudId(e.value)
                                                                                    setBatchId('');
                                                                                    // setInstitutionId('');
                                                                                }}
                                                                                options={studList.map(stud => ({
                                                                                    value: stud.coreUserId,
                                                                                    label: stud.coreUserName
                                                                                }))}
                                                                                placeholder={"Select Student"}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>From Date</h6></label>
                                                                        <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={fromDate} onChange={(e) => setFromDate(e.target.value)}></input>
                                                                    </div>
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>To Date</h6></label>
                                                                        <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={toDate} onChange={(e) => setToDate(e.target.value)}></input>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <div className="save-changes text-sm mt-4">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-primary save-profile"
                                                                                onClick={atndcReport}
                                                                            >
                                                                                Submit
                                                                            </Link>
                                                                            <Link
                                                                                to="#"
                                                                                className={`btn btn-primary save-profile`}
                                                                                // onClick={exportToExcel}
                                                                                onClick={exportnow}
                                                                            >
                                                                                Export to Excel
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                    {showTable && (
                                                                        <>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="dataTables_filter">
                                                                                    <label>
                                                                                        <input
                                                                                            type="text"
                                                                                            value={searchInput}
                                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                                            placeholder="Search"
                                                                                            className="form-control"
                                                                                        />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {showTable && (
                                                                <>
                                                                    <div className="tab-content">
                                                                        <div
                                                                            className="tab-pane fade show active"
                                                                            id="nav-Recent"
                                                                            role="tabpanel"
                                                                            aria-labelledby="nav-Recent-tab"
                                                                            tabIndex={0}
                                                                        >
                                                                            <div className="table-responsive table-datatble">
                                                                                <DataTable
                                                                                    className="table datatable"
                                                                                    value={filteredData}
                                                                                    paginator
                                                                                    rows={10}
                                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                    pageLinkSize={3}
                                                                                >
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="slNo"
                                                                                        body={slNoRender}
                                                                                        header="Sl No"
                                                                                    // headerStyle={{ backgroundColor: "#0f2a4e", color: "#FFFF" }}
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="batchName"
                                                                                        body={batchRender}
                                                                                        header="Batch"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="scheduleDate"
                                                                                        body={dateRender}
                                                                                        header="Date"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="yfhSkillsName"
                                                                                        body={skillRender}
                                                                                        header="Skill"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="studentName"
                                                                                        body={studRender}
                                                                                        header="Student Name"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="attendanceTypeName"
                                                                                        body={attendanceRender}
                                                                                        header="Attendance"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="attendanceComments"
                                                                                        body={commentRender}
                                                                                        header="Comments"
                                                                                    ></Column>
                                                                                    {/* <Column
                                                                                        body={detailsRender}
                                                                                    ></Column> */}
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {/* Batch Attendance List */}

            <div
                className="modal custom-modal fade request-modal"
                id="attendance-list"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Attendance Details
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row text-sm-end">
                                <div className="dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            placeholder="Search Students"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="table-responsive table-datatble">
                                    <table className="table datatable">
                                        <thead className="thead-light">
                                            <tr>
                                                <th className="text-uppercase">Sl No.</th>
                                                <th className="text-uppercase">Student Name</th>
                                                <th className="text-uppercase">Class</th>
                                                <th className="text-uppercase">Section</th>
                                                <th className="text-uppercase">Gender</th>
                                                <th className="text-uppercase">Attendance</th>
                                                <th className="text-uppercase">Attendance Comment</th>
                                            </tr>
                                            {Array.isArray(filteredAttendance) && filteredAttendance.map((atndc, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{atndc.StudentName}</td>
                                                    <td>{atndc.class}</td>
                                                    <td>{atndc.section}</td>
                                                    <td>{atndc.coreUserGender}</td>
                                                    <td>{atndc.attendanceName}</td>
                                                    <td>{atndc.Comments}</td>
                                                </tr>
                                            ))}
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Batch Attendance List */}
        </>
    )
};

export default attendanceReport;